
import pdfMake from 'pdfmake/build/pdfmake.js';
import htmlToPdfmake from "html-to-pdfmake";

const eventoClinicoPDF = async (data) => {

    console.log(data); //firma profesional -> profesional/ver-firma/id-profesional/token

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    const name = data.typeOfDocument + '-' + data.documentNumber + ' ' + data.names;

    const header = {
        margin: [40, 10, 0, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', '*'],
            body: [
                [{
                    image: await getImage(data.urlLogo),
                    fit: [100, 40],
                },
                { text: data.profile.nombre + '\n  NIT' + data.profile.nit + '\n Dirección: ' + data.profile.direccion.direccion + ' Teléfono:' + data.profile.telefono1, style: 'head' }]
            ]
        },
    };

    let tableDiagnostic = [];

    if (data.diagnostico != null) {
        tableDiagnostic.push(
            [{ text: 'CIE-10', bold: true }, { text: 'Descripción', bold: true }]
        );
        for (let i = 0; i < data.diagnostico.length; i++) {
            let diag = [{ text: data.diagnostico[i].codigo, style: 'textStyle' }, { text: data.diagnostico[i].nombre, style: 'textStyle' }]
            tableDiagnostic.push(diag);
        }
    }

    let urlServe = data.urlDoctorFirm;
    let urlFirma = '';
    let test = fetch(urlServe)
        .then(response => {
            if (response.status === 500) {
                return false;
            } else {
                return true;
            }
        });

    let isImg = await test;

    if (isImg) {
        urlFirma = urlServe;
    } else {
        urlFirma = 'https://i.postimg.cc/0jznYVsr/prueba.png';
    }

    const htmlSpeechTerapy = htmlToPdfmake(data.speechTerapy);

    console.log("dataPatientPrint", data);

    let anamesisOriginal = [
        [{ text: 'Anamnesis ', style: 'tableheader' }],
        [{ text: 'Motivo de Consulta ', bold: true, style: 'textStyle' }],
        [{ text: `${data.anamnesis != null && data.anamnesis != undefined ? data.anamnesis.motivo_consulta : ''}`, style: 'textStyle' }],
        [{ text: 'Enfermedad Actual ', bold: true, style: 'textStyle' }],
        [{ text: data.anamnesis.enfermedad_actual, style: 'textStyle' }]
    ]

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        header: header,
        defaultStyle: {
            fontSize: 9
        },
        pageMargins: [40, 60, 30, 30],
        info: {
            author: "Esteban Londoño",
        },
        /*footer: function (currentPage, pageCount) {
            return {
                table: {
                    widths: ['*', '*', '*'],
                    body: [
                        [{ text: "Página " + currentPage.toString() + ' de ' + pageCount, style: 'head' }, { text: name, style: 'head' }, { text: 'Fecha Impresión: ' + fecha, style: 'head' }],
                    ]
                },
                layout: 'noBorders',
                margin: [20, 0, 0, 5],
            };
        },*/
        content: [
            {
                margin: [0, 10, 0, 10],
                layout: 'headerLineOnly',
                table: {
                    headerRows: 1,
                    widths: ['auto', '*', 'auto', '*'],
                    body: [
                        [{ text: 'Datos del Paciente ', style: 'tableheader', colSpan: 2 }, '', '', ''],
                        [{ text: 'Tipo de Documento ', bold: true, style: 'textStyle' }, { text: data.typeDocument, style: 'textStyle' }, { text: 'Historia', bold: true, style: 'textStyle' }, { text: data.documentNumber, style: 'textStyle' }],
                        [{ text: 'Nombre ', bold: true, style: 'textStyle' }, { text: data.fullname, style: 'textStyle' }, { text: 'Fecha de Nacimiento ', bold: true, style: 'textStyle' }, { text: data.birthday, style: 'textStyle' }],
                        [{ text: 'Edad ', bold: true, style: 'textStyle' }, { text: data.age, style: 'textStyle' }, { text: 'Genero ', bold: true, style: 'textStyle' }, { text: data.gender, style: 'textStyle' }],
                        [{ text: 'Dirección ', bold: true, style: 'textStyle' }, { text: data.address, style: 'textStyle' }, { text: 'Ciudad ', bold: true, style: 'textStyle' }, { text: data.city, style: 'textStyle' }],
                        [{ text: 'Télefono ', bold: true, style: 'textStyle' }, { text: data.telephone, style: 'textStyle' }, { text: 'Celular ', bold: true, style: 'textStyle' }, { text: data.cellphone, style: 'textStyle' }]
                    ]
                },
            },
            {
                margin: [0, -5, 0, 5],
                layout: 'headerLineOnly',
                table: {
                    widths: ['auto', '*', 'auto', '*'],
                    headerRows: 1,
                    body: [
                        [{ text: 'Datos de la Cita ', style: 'tableheader', colSpan: 2 }, '', '', ''],
                        [{ text: 'EPS ', bold: true, style: 'textStyle' }, { text: data.nitThird + "-" + data.nameThird, style: 'textStyle' }, { text: 'Regimen ', bold: true, style: 'textStyle' }, { text: data.regime, style: 'textStyle' }],
                    ]
                },
            },
            { text: 'Responsable ', bold: true, style: 'textStyle' }, { text: data.responsable, style: 'textStyle' },
            {
                margin: [0, 0, 0, 15],
                layout: 'noBorders',
                table: {
                    widths: ['auto', '*', 'auto', '*', 'auto', '*', 'auto', '*'],
                    headerRows: 1,
                    body: [
                        [
                            { text: 'Fec Ingreso ', bold: true, style: 'textStyle' },
                            { text: data.dateAdmision != 'Fecha inválida' && data.dateAdmision != null && data.dateAdmision != undefined ? data.dateAdmision : null, bold: true, style: 'textStyle' },
                            { text: 'Hora ', bold: true, style: 'textStyle' },
                            { text: data.hourAdmision != 'Fecha inválida' && data.hourAdmision != null && data.hourAdmision != undefined ? data.hourAdmision : null, bold: true, style: 'textStyle' },
                            { text: 'Fec Salida ', bold: true, style: 'textStyle' },
                            { text: data.dateOutPatient != 'Fecha inválida' && data.dateOutPatient != null && data.dateOutPatient != undefined ? data.dateOutPatient : null, bold: true, style: 'textStyle' },
                            { text: 'Hora ', bold: true, style: 'textStyle' },
                            { text: data.hourOutPatient != 'Fecha inválida' && data.hourOutPatient != null && data.hourOutPatient != undefined ? data.hourOutPatient : null, bold: true, style: 'textStyle' }
                        ]
                    ]
                },
            },
            {
                margin: [0, -15, 0, 15],
                layout: 'noBorders',
                table: {
                    widths: ['auto', '*'],
                    headerRows: 1,
                    body: [
                        [{ text: 'Medico Remitente ', bold: true, style: 'textStyle' }, { text: data.remitentDoctor, style: 'textStyle' }],
                        [{ text: 'Procedimiento ', bold: true, style: 'textStyle' }, { text: data.codigoService + "-" + data.nameService, style: 'textStyle' }],
                    ]
                },
            },
            data.anamnesis !== null && data.anamnesis !== undefined ?
                {
                    margin: [0, -10, 0, 15],
                    layout: 'headerLineOnly',
                    table: {
                        widths: ['*'],
                        headerRows: 1,
                        body: anamesisOriginal
                    },
                } : null,
            {
                margin: [0, -5, 0, 10],
                layout: 'headerLineOnly',
                table: {
                    widths: [200, '*', '*', '*'],
                    headerRows: 1,
                    body: [
                        [{ text: 'Procedimiento Audiologico ', style: 'tableheader' }, '', '', ''],
                        [{ text: '', style: 'tableheader' }, '', '', ''],
                    ]
                },
            },
            {
                margin: [0, -15, 0, 10],
                layout: 'headerLineOnly',
                table: {
                    widths: ['auto'],
                    headerRows: 1,
                    body: [
                        [htmlSpeechTerapy],
                    ]
                },
            },
            tableDiagnostic.length > 0 ? {
                margin: [0, -5, 0, 10],
                layout: 'headerLineOnly',
                table: {
                    widths: ['*', '*', '*', '*'],
                    headerRows: 1,
                    body: [
                        [{ text: 'Diagnosticos ', style: 'tableheader' }, '', '', ''],
                        [{ text: '', bold: true, style: 'textStyle' }, '', '', '']
                    ]
                },
            } : null,
            tableDiagnostic.length > 0 ? {
                margin: [0, -15, 0, 10],
                layout: 'noBorders',
                table: {
                    widths: [50, 'auto'],
                    headerRows: 1,
                    body: tableDiagnostic
                },
            } : null,
            {
                margin: [0, 0, 0, 0],
                image: await getImage(urlFirma),
                fit: [80, 80],
            },
            {
                text: data.nameDoctor + '\n' + data.specialtyDoctor + '- REG ' + data.medicalRegister, style: 'medicStyle'
            },
        ],
        styles: {
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            tableheader: {
                fontSize: 11,
                bold: true,

            },
            textStyle: {
                fontSize: 9,
            },
            tableTexStyle: {
                fontSize: 8,
                alignment: 'left'
            },
            foter: {
                alignment: 'center',
                fontSize: 6,
            },
            medicStyle: {
                margin: [0, 5, 0, 0],
                fontSize: 10,
                alignment: 'left',
            }
        }
    };

    
    //pdfMake.createPdf(documentDefinition).open();

    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
    
    function getImage(url) {
        return new Promise((resolve, reject) => {
            var img = new Image();
            img.setAttribute("crossOrigin", "anonymous");

            img.onload = () => {
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;

                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                var dataURL = canvas.toDataURL("image/png");

                resolve(dataURL);
            };
            img.onerror = error => {
                reject(error);
            };

            img.src = url;
        });
    }
}

export default eventoClinicoPDF;